function arrayToTree(items) {
    // Create a map of items by their IDs
    
  let array = [];
  items.forEach(item => {
    let obj = {_id: item._id, name: item.name};
    let obj1 = {plan: item.plan, children: [obj]};
    let findPlan = array.findIndex(arr => arr.plan === item.plan);
    if (findPlan === -1) {
      array.push(obj1);
    }else {
      array[findPlan].children.push(obj);
    }
  });
  return array;
}

export default arrayToTree;
